module.exports = __webpack_public_path__ + "static/media/peer_rating_intro.32e6eace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer_rating_intro.svg
// module id = 1909
// module chunks = 0